<template>
    <v-snackbar
      multi-line
      color="success"
      :timeout="5000"
      class="pa-15 font-weight-bold"
      v-model="snackbar"
    >
      <v-container>
        <v-row class="" align-content="center" align-items="center">
          <v-col cols="auto" class="align-self-center">
            <v-icon
              class="pr-8"
              size="50"
              color="white"
            >
              mdi-check-circle
            </v-icon>
          </v-col>
          <v-col class="font-weight-black" style="font-size: 1.1rem">
            <v-container class="pt-4">
              <v-row v-if="successLabel != ''">
                <v-col class="pa-0 text-uppercase">{{successLabel}}:</v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0">
                  {{ successMessage }}
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      <template v-slot:action="{ attrs }">
        <v-btn color="green" text v-bind="attrs" @click="snackbar = false">
          <v-icon color="white">mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
</template>
<script>
export default {
  props: {
    successMessage: {
      type: String,
      default: '',
    },
    successLabel: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      snackbar: this.value,
    }
  },
  watch: {
    value (val) {
      this.snackbar = val
    },
    snackbar (val) {
      this.$emit('input', val)
    },
  },
}
</script>
